import { RouteObject } from 'react-router-dom';
import { CreatePayment } from './components';
import PaymentsLandingPage from './components/landing/landing';
import PaymentReceiptSuccessPage from './components/receipt/receipt';


export interface paymentRoute extends Omit<RouteObject, 'children'> {
  auth?: boolean;
  children?: paymentRoute[];
}

export const paymentRoutes: paymentRoute[] = [
  {
      path: 'cx/payments',
      element: <PaymentsLandingPage />,
    },
    {
      path: 'cx/payments/create',
      element: <CreatePayment />,
    },
    {
      path: 'cx/payments/create/:action',
      element: <CreatePayment />,
    },
    {
      path: 'cx/payments/success',
      element: <PaymentReceiptSuccessPage />,
    },
];
